<template>
    <v-card>
        <v-card-text>
            {{environment ? environment.environment_type.desc : 'none'}}
        </v-card-text>
    </v-card>
</template>

<script>
    export default {
        name: "Environment",
        props:{
            customer_id:{
                required: true,
            }
        },
        computed:{
            environment(){
                return this.$store.$db().model('environments').query().with('environment_type').find(this.customer_id)
            }
        },
        mounted(){
            this.loadData();
        },
        methods:{
            async loadData(){
                this.loading = true;
                await this.$store.$db().model('environments').api().fetch({
                    where: {
                        key: 'customer_id',
                        value: this.customer_id
                    },
                    with: 'environmentType'
                })
                this.loading = false;
            }
        }
    }
</script>

<style scoped>

</style>
